import React from 'react';
import PropTypes from 'prop-types';
import { FaTimes, FaCircle } from 'react-icons/fa';
import './styles.scss';

function EpBadge({
  children, color, type, state,
}) {
  return (
    <span className={`badge  ${state === 'disabled' ? `badge--${color}-disabled` : `badge--${color}`}`}>
      {type === 'times' ? (
        <button className={`btn  ${state === 'disabled' ? `btn--${color}-disabled` : `btn--${color}`}`}>
          <FaTimes />
        </button>
      ) : (
        <FaCircle className={`icon  ${state === 'disabled' ? `icon--${color}-disabled` : `icon--${color}`} `} />
      )}
      <span>{children}</span>
    </span>
  );
}

export default EpBadge;

EpBadge.defaultProps = {
  color: 'default',
  type: 'default',
  state: 'default',
};

EpBadge.propTypes = {
  children: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['default', 'danger', 'new', 'success', 'warning']),
  type: PropTypes.oneOf(['default', 'times']),
  state: PropTypes.oneOf(['default', 'disabled']),
};
